import ddt from '@wix/da-ddt';

const logger = ddt.createLogger('profiles');
export default logger;
